import React from 'react';
import { Card, Typography, Row, Col, Progress } from 'antd';

const { Text, Title } = Typography;

const CaptureRatios = ({ upside, downside }) => {
  return (
    <Card bordered={false}
          className={'gapless-y'}
          title={<Title level={4} style={{fontFamily: "Quicksand, sans-serif"}}>Upside/Downside Capture</Title>}
    >

      <div style={{ padding: '20px 10px', textAlign: 'center' }}>
      <Row gutter={16}>
        <Col span={12}>
          <Text strong color={'green'} style={{ color: 'green', fontSize: '1.5em' }}>{upside?.toFixed(1)}%</Text>
        </Col>
        <Col span={12}>
          <Text strong style={{ color: 'red', fontSize: '1.5em' }}>{downside?.toFixed(1)}%</Text>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Progress
            percent={100}
            showInfo={false}
            strokeColor={{
              '0%': 'green',
              '100%': 'red',
            }}
            strokeLinecap="square"
            strokeWidth={10}
          />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <span style={{fontSize: '11px', fontWeight: '600'}}>Compares Upside & Downside Performance to Benchmark</span>
        </Col>
      </Row>
    </div>
    </Card>
  );
};

export default CaptureRatios;
